import axiosTokenInstance from '../../../services/api/backoffice';
import { ICC_UNLOCKING, ICC_UNLOCKING_ERROR } from '_models/redux/types';

// Action function
export const actionIccUnlockingAction = (params) => async (dispatch) => {
  const { reason, iccid } = params || {};
  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.patch(
      `api/ipb/sims/${iccid}/status-to-idle`,
      { reason },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );

    dispatch({
      type: ICC_UNLOCKING,
      payload: response || {},
    });

    return response;
  } catch (e) {
    dispatch({
      type: ICC_UNLOCKING_ERROR,
      payload: e || {},
    });
    return e;
  }
};
